import { ChevronLeft } from 'lucide-react';
import { cn } from '@/lib/utils';

interface QuizBackButtonProps {
  onClick: () => void;
  className?: string;
}

export function QuizBackButton({ onClick, className }: QuizBackButtonProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-label="Back"
      className={cn(
        'flex size-9 items-center justify-center rounded-full bg-white shadow-[0_0_16px_rgba(26,22,19,0.03)]',
        className,
      )}
    >
      <ChevronLeft className="size-5 text-mf-neutral-900" strokeWidth={1.75} />
    </button>
  );
}
